<template>
  <div class="continuous-auctions-lots-list page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Lots')">
      <template v-slot:buttons>
        <add-new-button v-permission="'change_inventoryitem'" @click="onNewLotClick">
          <font-awesome-icon icon="plus-circle" class="icon"/>
          {{ $t('New Lot') }}
        </add-new-button>
      </template>
    </page-header>
    <div class="card content-wrapper p-2">
      <LotsTable v-if="loadTable" :hide-actions="hideActions" :exclude-columns="['low', 'sale_no', 'proposal_suggestion', 'proposal_status', 'new_low', 'new_high', 'new_reserve', 'new_start_price', 'proposal_sent_at', 'proposal_sent_by', 'proposal_confirmed_at', 'proposal_confirmed_by']"
                 :exclude-search-fields="['auction_collection_uuid', 'bidder_uuid', 'proposal_suggestion', 'proposal_status']" enable-frontend-export/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import {
    ACTION_ARCHIVE_LOT,
    ACTION_BATCH_LOT_UP,
    ACTION_BATCH_UPDATE_AUCTION_LOT_IMAGES,
    ACTION_BATCH_UPDATE_SESSION,
    ACTION_DELETE_LOT,
    ACTION_LOT_EXPORT_ALL_IMAGES,
    ACTION_LOT_UP,
    ACTION_LOT_UP_USING_EXCEL,
    ACTION_LOT_UP_USING_QR,
    ACTION_LOT_UPLOAD_IMAGES,
    ACTION_LOT_UPLOAD_ZIP,
    ACTION_REVERT_TO_COMPLETED_LOT,
    CONTINUOUS_ACTION_LOT_EXPAND,
    SOURCE_LOTS_TABLE
  } from "../constants";
  import LotsTable from "./LotsTable";
  import PageHeader from "../../core/components/page-header/PageHeader";
  import AddNewButton from "../../core/components/common/AddNewButton";

  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions: lotsMapActions} = createNamespacedHelpers('lots');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "LotsList",
    components: {AddNewButton, PageHeader, LotsTable},
    data() {
      return {
        hideActions: [
          ACTION_LOT_UP,
          ACTION_LOT_UP_USING_QR,
          ACTION_BATCH_LOT_UP,
          ACTION_LOT_UPLOAD_IMAGES,
          ACTION_LOT_UPLOAD_ZIP,
          // ACTION_MARK_UNSOLD,
          ACTION_DELETE_LOT,
          ACTION_LOT_EXPORT_ALL_IMAGES,
          ACTION_ARCHIVE_LOT,
          ACTION_REVERT_TO_COMPLETED_LOT,
          ACTION_LOT_UP_USING_EXCEL,
          ACTION_BATCH_UPDATE_SESSION,
          ACTION_BATCH_UPDATE_AUCTION_LOT_IMAGES
        ],
        loadTable: true,
      }
    },
    computed: {
      ...mapState({sale: state => state.view.currentSale}),
      ...globalMapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
    },
    methods: {
      ...lotsMapActions(['updateTableSource', 'showModal']),
      onNewLotClick() {
        this.showModal({
          object: {},
          sale: {},
          source: SOURCE_LOTS_TABLE
        });
      },
    },
    async beforeMount() {
      if (this.enableContinuousAuction) {
        await this.updateTableSource({
          source: 'lot',
          extraExpands: CONTINUOUS_ACTION_LOT_EXPAND
        })
      } else if (this.$route.path === '/lots') {
        this.loadTable = false;
        await this.$router.push({name: 'not-found'});
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .continuous-auctions-lots-list {
    @include list-view-wrapper;
  }
</style>
